<template>
  <div v-if="$site?.location" class="overflow-x-hidden">
    <NuxtLayout>
      <NuxtPage/>
    </NuxtLayout>

    <UNotifications />

    <div id="teleports" class="bottom-16 relative w-full" />
  </div>
</template>

<script setup lang="ts">
useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk;
  }
})

defineOgImageComponent('Preview')
</script>